<!DOCTYPE html>
<html lang="en" class="perfect-scrollbar-off">
<meta http-equiv="content-type" content="text/html;charset=utf-8" />

<head>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
  <title>Master Module</title>
  <meta content='width=device-width, initial-scale=1.0, shrink-to-fit=no' name='viewport' />
  <!-- Extra details -->
  <!-- Social tags -->
  <meta name="keywords" content="">
  <meta name="description" content="">
</head>

<body class="sidebar-mini tanuvas">

  <app-sidebar></app-sidebar>
  <div class="main-panel">
    <!-- Navbar -->
    <app-navbar></app-navbar>
    <!-- End Navbar -->
    <div class="wrapper " style="overflow-y:scroll">
      <router-outlet></router-outlet>
      <!-- <footer class="footer">
        <div class="container-fluid">
          <nav class="float-left">
            <ul>
              <li>
                <a href="#">
                  Creative Tim
                </a>
              </li>
              <li>
                <a href="#">
                  About Us
                </a>
              </li>
              <li>
                <a href="#">
                  Blog
                </a>
              </li>
              <li>
                <a href="#">
                  Licenses
                </a>
              </li>
            </ul>
          </nav>
          <div class="copyright float-right">
            &copy;                      
            <script>
              document.write(new Date().getFullYear())
            </script>, All Right reserved by
            <a href="#" target="_blank">Redantmedia</a> 
          </div>
        </div>
      </footer>-->
    </div>
  </div>
  <!--   Core JS Files   -->
</body>

</html>